module.exports = __webpack_public_path__ + "img/green-pita-06.d4fb8366.png";